export default __webpack_public_path__ + "static/media/bkg--enquire.95cedf61.jpg";